import { TableCell, TableCellProps } from '@mui/material';
import { styled } from '@mui/material/styles';


export const TruxTableCell = styled(TableCell)<TableCellProps>(() => (
  {
    paddingLeft: "10px",
    paddingRight: "10px",
    ':last-child': {
      paddingRight: "12px"
    },
    ':first-of-type': {
      paddingLeft: "12px"
    },
  }
));
